import { nnSlideUp } from "./inc/helpers";

const STORAGE_KEY = 'headerAlertDismissed';

function todayKey() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function headerAlertBar() {
    const $alert = document.getElementById('header-alert');
    const $alertClose = document.getElementById('header-alert-close');

    if (!$alert || $alert.hidden) {
        return;
    }

    const contentKey = $alert.querySelector('.container')?.textContent?.trim() ?? '';

    $alertClose?.addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            content: contentKey,
            date: todayKey(),
        }));
        nnSlideUp($alert, 300);
    });
}
